/**
 * Tab-scoped persistence for the accountless-OTP phone number.
 *
 * The self-onboarding step lives in the URL but the entered phone number lives
 * only in in-memory flow state, so a reload on the OTP screen wipes it — leaving
 * "request another code" with nothing to send (it fired
 * `startAnonymousPhoneVerification` with an empty input). Persisting the number
 * lets the resend survive a reload without forcing the worker to re-enter it.
 *
 * sessionStorage (tab-scoped, dropped on tab close) is used rather than a URL
 * query param to keep the phone number — PII — out of browser history, server
 * access logs, `Referer` headers, and RUM. All accessors are SSR-guarded since
 * the flow is server-rendered.
 */
const STORAGE_KEY = 'selfOnboarding.verificationPhoneNumber';

export const saveVerificationPhoneNumber = (phoneNumber: string): void => {
  if (typeof window === 'undefined' || !phoneNumber) return;
  window.sessionStorage.setItem(STORAGE_KEY, phoneNumber);
};

export const readVerificationPhoneNumber = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window.sessionStorage.getItem(STORAGE_KEY) ?? undefined;
};

export const clearVerificationPhoneNumber = (): void => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_KEY);
};
